import {AppButton} from '@/components/Button';
import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import {LOGIN_TYPE_CODE, LoginTypeCode} from '@/consts/loginTypes';
import appContent from '@/services/content/appContent.typed';

interface LoginMethodSwitchProps {
    currentMethod: LoginTypeCode;
    onSwitch?: () => void;
}

const LoginMethodSwitch = ({currentMethod, onSwitch}: LoginMethodSwitchProps) => {
    const {additionalSectionTitle, switchToLoginPasswordButton, switchToOtpButton} = appContent.getOtpContent();

    const isPassword = currentMethod === LOGIN_TYPE_CODE.LOGIN_PASSWORD;
    const button = isPassword ? switchToOtpButton : switchToLoginPasswordButton;

    if (!button) return null;

    const {text, icon} = button;
    const hasIcon = icon?.path;

    const handleClick = (): void => {
        onSwitch?.();
    };

    return (
        <>
            {additionalSectionTitle && <div className='text-center'>{additionalSectionTitle}</div>}
            <div className='flex flex-col'>
                <AppButton secondary light onClick={handleClick} className='m-0 w-full'>
                    <div className='flex justify-between gap-4 ml:justify-center'>
                        {hasIcon && <RemoteIconV2 icon={icon} className='h-6 w-6 shrink-0' />}
                        {text}
                        {hasIcon && <div className='w-6 shrink-0' />}
                    </div>
                </AppButton>
            </div>
        </>
    );
};

export default LoginMethodSwitch;
